/* eslint-disable no-console */
import { Alert, Flex, Heading } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';

import { DataPipeline } from '@finley-technologies/finley-types';

import { InstanceGraphProvider } from '../../hooks/instanceGraphContext';
import { GraphRenderer } from './GraphRenderer';
import { InstanceOptionalDrawer } from './InstanceDrawer';

export const DataPipelineDetails = ({
  meshId: meshRunId,
  organizationId: _unused,
}: {
  meshId: string;
  organizationId: string;
}) => {
  if (!DataPipeline.isMeshId(meshRunId)) {
    return <Alert>InValid meshId: ${meshRunId}</Alert>;
  }
  return (
    <>
      <Link to="../list" style={{ color: 'blue', textDecoration: 'underline' }}>
        Back to List
      </Link>

      <Flex justify="space-between" width="100%">
        <Heading mt="10px" marginBottom="70px" display="inline-block">
          ID: {meshRunId}
        </Heading>
      </Flex>
      <InstanceGraphProvider meshRunId={meshRunId}>
        <GraphRenderer />
        <InstanceOptionalDrawer />
      </InstanceGraphProvider>
    </>
  );
};
